import {isElectron} from '../../../libs/shared/core/src/helpers/environment/platformHelpers';

const grammarlyWebClientId = 'client_6QtF8pxJtemge937fRnPPN';
const grammarlyDesktopClientId = 'client_QuVmHBZeYoGqUHZUkGFjJw';
const grammarlyPremiumWebClientId = 'client_7kZqGhJKLhPtQRZvT9SV3d';
const grammarlyPremiumDesktopClientId = 'client_PzYgj7XjpJVCUQ7BahCGUc';
const grammarlyRedirectUri = 'frontapp://grammarly-auth';

export function getGrammarlyClientId(hasGrammarlyPremium: boolean) {
  if (!isElectron()) {
    return hasGrammarlyPremium ? grammarlyPremiumWebClientId : grammarlyWebClientId;
  }
  return hasGrammarlyPremium ? grammarlyPremiumDesktopClientId : grammarlyDesktopClientId;
}

export function getGrammarlyRedirectUri() {
  if (!isElectron()) {
    return undefined;
  }

  return grammarlyRedirectUri;
}
